import { mutator } from 'satcheljs';
import getStore from '../store/store';
import selectOldMeetingMessageOption from '../../actions/selectOldMeetingMessageOption';
/**
 * Called when there is a change in the remove old meeting message option
 */
export default mutator(selectOldMeetingMessageOption, function (actionMessage) {
    var optionState = getStore();
    optionState.removeOldMeetingMessages = actionMessage.removeOldMeetingMessages;
});
//# sourceMappingURL=selectOldMeetingMessageOption.js.map